import React, { memo } from "react";

import { Box, Button, Card, Stack, Typography } from '@material-ui/core';
import { ChatData } from "../../../types";
import { ProfileAvatar } from "../../../components/UserPhoto/UserPhoto";
import timeAgo from "../../../utils/timeAgo";
import { Link } from "@reach/router";

import { areEqual, ListChildComponentProps } from 'react-window';


const _ChatItem: React.FC<ListChildComponentProps<ChatData[]>> = ({ data, index, style }) => {

  const chat = data[ index ];

  return (
    <Box style={style} sx={{ pb: 1, minWidth: 550}}>
      <Card variant="outlined" sx={{ padding: 1 }}>

        <Stack direction="row" alignItems="center" justifyContent="space-between">

          <Stack direction="column" spacing={0.2} alignItems="center">
            <Stack direction="row" spacing={1}>
              <ProfileAvatar userId={chat.users[ 0 ]} size={100} />
              <ProfileAvatar userId={chat.users[ 1 ]} size={100} />
            </Stack>
            <Typography variant="caption">
              Status: {chat.status}
            </Typography>
            <Typography variant="caption">
              Created: {timeAgo(chat.createTime.toDate())}
            </Typography>
            <Typography variant="caption">
              Updated: {timeAgo(chat.updateTime.toDate())}
            </Typography>
          </Stack>

          <Stack direction="column">
            <Typography variant="body2" noWrap>Total messages: {chat.messagesCount?.total}</Typography>
            <Typography variant="body2" noWrap>Active: {chat.messagesCount?.active}</Typography>
            <Typography variant="body2" noWrap>Text: {chat.messagesCount?.text}</Typography>
            <Typography variant="body2" noWrap>Photo: {chat.messagesCount?.photo}</Typography>
            <Typography variant="body2" noWrap>Giphy: {chat.messagesCount?.giphy}</Typography>
            <Typography variant="body2" noWrap>Sticker: {chat.messagesCount?.sticker}</Typography>
            <Typography variant="body2" noWrap>Voice: {chat.messagesCount?.voice}</Typography>
          </Stack>

          <Button component={Link} to={`/chats/${chat.id}`}>
            View
          </Button>

        </Stack>
      </Card>
    </Box>
  );
};

const ChatItem = memo(_ChatItem, areEqual);

export default ChatItem;